import { createContext, useContext } from 'react'
import type { AuthAccount, AuthContextValue } from './useAuth.types'

export type { AuthAccount, AuthContextValue }

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
